import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "'Assistant', sans-serif",
    fontWeight: 800,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <div dir="rtl">
      <App />
    </div>
  </ThemeProvider>
);
